const dashboard = {
  "dashboard-new-number-title": "ID Count",
  "dashboard-new-demography-title": "Demography",
  "dashboard-new-trend-title": "Trend",
  "dashboard-new-kpi-title": "Causal KPI",

  "dashboard-new-asset-title": "Variable Balance",

  "dashboard-new-asset-balance-title1": "Number of entries",
  "dashboard-new-asset-balance-title2": "Number of entries",

  "dashboard-new-asset-balance-attr1": "Covariates / Confounders",
  "dashboard-new-asset-balance-attr2": "Treatment variables",
  "dashboard-new-asset-balance-attr3": "Outcome variables",

  "dashboard-new-asset-ranking-title1": "Covariate / Confounding Factors",
  "dashboard-new-asset-ranking-title2": "Treatment Variables",

  "dashboard-new-asset-heatmap-legend1":
    "Abundant data (analysis fully feasible)",
  "dashboard-new-asset-heatmap-legend2": "Available data (analysis feasible)",
  "dashboard-new-asset-heatmap-legend3":
    "Limited data (analysis not recommended)",

  "dashboard-new-prior-title": "Causal Asset",

  "dashboard-demographics-label": "Demographics",
  "dashboard-demographics-ratio-label": "Ratio",
  "dashboard-demographics-condition-level-label": "Demographic",

  "dashboard-kpi-title": "Key KPI Trends",
  "dashboard-kpi-popover-button": "Settings",
  "dashboard-kpi-reorder-reset-button": "Reset",
  "dashboard-kpi-reorder-save-button": "Save",
  "dashboard-kpi-reorder-max-message": "The maximum number of KPI items is 8.",
  "dashboard-kpi-reorder-min-message": "The minimum number of KPI items is 1.",

  "demographics-genders-label": "Genders",
  "demographics-ages-label": "Ages",
};

export default dashboard;
